import _ from "lodash";
import React, { createRef } from "react";
import PropTypes from "prop-types";
import ButtonDropdown from "UIComponents/ButtonDropdown";
import SearchBarWithTag from "UIComponents/SearchBarWithTag";
import UIBaseComponent from "UIComponents/UIBaseComponent";
import classes from "./GroupSelectDropdown.scss";
import CheckboxGroup from "./CheckboxGroup";

const dropDownStyle = {
  containerStyle: {
    width: "100%",
    flex: 1,
    minHeight: 0,
    marginTop: "24px",
    borderRadius: "4px",
    marginBottom: "8px",
    maxHeight: "368px",
    overflowY: "auto",
    padding: "24px",
  },
  buttonParentStyle: {
    width: "100%",
    flexDirection: "column",
    height: "100%",
  },
  parentContainerStyle: {
    height: "100%",
  },
};

const searchBarWithTagStyles = {
  tagListContainer: {
    marginTop: "0px",
  },
  searchBarWithTagContainer: {
    alignItems: "center",
    padding: "8px 0px 8px 16px",
  },
  searchBarContainer: {
    width: "100%",
    paddingLeft: "0 12px 0 0",
  },
  tag: {
    container: {
      margin: "4px 8px 4px 0",
      maxHeight: "32px",
    },
  },
};

const checkBoxStyle = {
  checkboxItemStyle: {
    width: "18px",
    height: "18px",
    borderRadius: "4px",
  },
};

class GroupSelectDropdown extends UIBaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      searchText: "",
      error: "",
    };

    this.inputSearchBar = createRef(null);
  }

  updateSearchText = value => this.setState({ searchText: value });

  removeOption = (item, event) => {
    if (event) event.stopPropagation();
    const updatedValues = _.filter(this.props.value, id => id != item.value);
    this.updateValue(updatedValues);
  };

  filterOptions = () => {
    const { options } = this.props;
    const { searchText } = this.state;

    const filteredOptions = [];

    _.forEach(options, group => {
      if (_.includes(_.lowerCase(group.label), _.lowerCase(searchText)))
        filteredOptions.push({ ...group });
      else {
        const matchedOptions = _.filter(group.options, option =>
          _.includes(_.lowerCase(option.label), _.lowerCase(searchText))
        );

        if (matchedOptions.length)
          filteredOptions.push({
            label: group.label,
            options: matchedOptions,
          });
      }
    });
    return filteredOptions;
  };

  getSelectedTags = () => {
    const { options, value } = this.props;
    const selectedTags = [];
    _.forEach(options, group => {
      _.forEach(group.options, item => {
        if (
          _.includes(value, item.value) &&
          !_.find(selectedTags, tagItem => tagItem.value == item.value)
        )
          selectedTags.push(item);
      });
    });
    return selectedTags;
  };

  renderEdit = () => {
    const { error, searchText } = this.state;
    const {
      placeholder,
      value,
      options,
      checkboxGroupName,
      onFocusInputField,
      searchBarStyles,
    } = this.props;
    const selectedTags = this.getSelectedTags();

    return (
      <div className={classes.container}>
        <ButtonDropdown
          {...dropDownStyle}
          buttonComponent={
            <SearchBarWithTag
              removeOption={this.removeOption}
              ref={ref => (this.inputSearchBar = ref)}
              placeholder={placeholder}
              error={error}
              showErrorText={false}
              value={selectedTags}
              searchText={searchText}
              onSearchChange={this.updateSearchText}
              showArrow={true}
              styles={{ ...searchBarWithTagStyles, ...searchBarStyles }}
              onFocusInputField={onFocusInputField}
              tagTheme={"black"}
              inlineView={true}
            />
          }
          dropdownComponent={
            <CheckboxGroup
              options={searchText.length ? this.filterOptions() : options}
              value={value}
              updateInputField={this.updateValue}
              searchText={searchText}
              checkboxGroupName={checkboxGroupName}
              checkboxItemStyle={checkBoxStyle.checkboxItemStyle}
            />
          }
          shouldCloseOnSelfClick={false}
        />
      </div>
    );
  };
}

GroupSelectDropdown.defaultProps = {
  ...UIBaseComponent.defaultProps,
  options: [],
  searchBarStyles: {},
};

GroupSelectDropdown.propTypes = {
  ...UIBaseComponent.propTypes,
  options: PropTypes.array,
};

export default GroupSelectDropdown;
